module.exports = require("@magento/peregrine/lib/talons/MiniCart/miniCartFragments.gql");